var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-tick-5153459",
    d: "M63.251,56.25a7,7,0,1,0,7,7A7,7,0,0,0,63.251,56.25Zm0,.483a6.517,6.517,0,1,1-6.518,6.516A6.512,6.512,0,0,1,63.251,56.733Zm3.084,3.928a.242.242,0,0,0-.165.083l-3.874,4.5L60.322,63.2a.241.241,0,1,0-.347.335l2.159,2.228h0a.241.241,0,0,0,.356-.011l4.045-4.7a.241.241,0,0,0-.2-.4Z",
    transform: "translate(-55.75 -55.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageDone);
export default __webpack_public_path__ + "static/media/messageDone.e01d2b04eb7a5f2add76ab067cff260a.svg";
export { ForwardRef as ReactComponent };